import React from "react";
import { motion } from "framer-motion";

export function CircularProgressBar(props) {
  const { countdown } = props;
  const outerColor = {
    background: "#152858",
    after: {
      background: "#152858",
    },
  };
  const timeVariants = {
    hidden: { scale: 0.7 },
    visible: {
      scale: 1,
      transition: {
        duration: 0.5,
        repeat: Infinity,
        repeatType: "reverse",
      },
    },
    exit: { scale: 0 },
  };

  return (
    <div
      onClick={props.onPress}
      className="pie-timer-sbs"
      style={countdown === 0 ? { ...outerColor } : {}}
    >
      <div className="pie-timer">
        <motion.h5 className="time" variants={timeVariants}>
          {countdown}
        </motion.h5>
        <h5 className="sec">SEC</h5>
        <span className="disable-enable-text">Click to Disable</span>
      </div>
    </div>
  );
}
